// Article/News types + shared constants for the News feature. (Was mockNews.ts
// during the mock phase; the mock data is gone now that the real API is wired.)

export interface NewsItem {
  id: number;
  label: string;
  description: string;
  image?: string;
  thumbnail?: string;
  sourceUrl?: string;
  isRead?: boolean;     // per-user (server) read state
}

export interface NewsDetail extends NewsItem {
  title: string;
  heroImage?: string;
  content?: string;
  publishedAt?: string;
}

export const NEWS_PAGE_PATH = '/news';
export const NEWS_PER_PAGE = 10;
export const NEWS_LOAD_BATCH_TOUCH = 6;
